/**
* Created by vouill on 2019-02-05.
*/

<template>
  <div>
    <AuthorContent
      :author="currentAuthor"
      :includes="includes"/>
    <article-list-author :author-id="currentAuthor.sys.id"/>
    <VideoListAuthor :author-id="currentAuthor.sys.id"/>
    <event-list-author :author-id="currentAuthor.sys.id"/>
  </div>
</template>

<script>
import AuthorContent from "./AuthorContent";
import ArticleListAuthor from "./article-list-author";
import EventListAuthor from "./event-list-author";
import VideoListAuthor from "./video-list-author";
export default {
  name: "Content",
  props: { authors: Array, includes: Object },
  components: {
    VideoListAuthor,
    EventListAuthor,
    ArticleListAuthor,
    AuthorContent
  },
  computed: {
    currentAuthor() {
      return this.$route.params.authorId
        ? this.authors.find(
            author => author.fields.slug === this.$route.params.authorId
          )
        : this.authors[0];
    }
  }
};
</script>
